import { faBoxArchive, faCalendarEdit, faCheck, faHardHat, faRepeat, faRoute, faSnowflake, faUser } from "@fortawesome/pro-solid-svg-icons"
import { Tooltip } from "antd"
import { faStopwatch } from "@fortawesome/pro-duotone-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

type Props = {
  eventInfo: any
}

const CalendarEvent = ({eventInfo}: Props) => {
  const frozen = eventInfo.event.extendedProps.originalEvent.frozen
  const recurring = eventInfo.event.extendedProps.originalEvent.recurring && eventInfo.event.extendedProps.originalEvent.project?.type !== 2
  const completed = (eventInfo.event.extendedProps.originalEvent.project?.status === 3 && eventInfo.event.extendedProps.originalEvent.project?.type === 1) 
    || (eventInfo.event.extendedProps.originalEvent.project?.tasksStatus === 3 && eventInfo.event.extendedProps.originalEvent.project?.type !== 1)
  const isConsultation = eventInfo.event.extendedProps.originalEvent.consultation !== null
  
  return (
    <div>
        <b>{eventInfo.timeText}
        </b>
        <span style={{marginLeft: '5px'}}>
          {frozen && <span style={{marginLeft: '5px'}}><Tooltip title="Frozen"><FontAwesomeIcon icon={faSnowflake}/></Tooltip></span>}
          {completed && <span style={{marginLeft: '5px'}}><Tooltip title="Completed"><FontAwesomeIcon icon={faCheck}/></Tooltip></span>}
          {recurring && <span style={{marginLeft: '5px'}}><Tooltip title="Recurring"><FontAwesomeIcon icon={faRepeat}/></Tooltip></span>}
          {isConsultation && <span>
            {eventInfo.event.extendedProps.originalEvent.consultation?.status === 4 ? 
            <Tooltip title="Canceled"><span style={{textDecoration: 'line-through'}}>Consultation</span></Tooltip> :
            <span>Consultation</span>
            }
            <div>
              <small>
                <span style={{marginRight: '5px'}}><Tooltip title="Customer"><FontAwesomeIcon icon={faUser}/></Tooltip></span>
                {eventInfo.event.extendedProps.originalEvent.consultation?.customer.displayName}
                {eventInfo.event.extendedProps.originalEvent.consultation?.customer.propertyNickname && `, (${eventInfo.event.extendedProps.originalEvent.consultation?.customer.propertyNickname})`}
              </small>
            </div>
          </span>
          }
          {!isConsultation && <span>
                {eventInfo.event.extendedProps.originalEvent.project?.customer.displayName}
                {eventInfo.event.extendedProps.originalEvent.project?.customer.propertyNickname && `, (${eventInfo.event.extendedProps.originalEvent.project?.customer.propertyNickname})`}
            <br />
            {eventInfo.event.extendedProps.originalEvent.workarea && <span style={{marginLeft: '5px'}}>
              <small>
                <span style={{marginRight: '5px'}}><Tooltip title="Workarea"><FontAwesomeIcon icon={faHardHat}/></Tooltip></span>
                {eventInfo.event.extendedProps.originalEvent.workarea.name}
              </small>
              <br/>
            </span>
            }
            <span style={{marginLeft: '5px'}}>
            <span style={{marginRight: '5px'}}><Tooltip title="Project"><FontAwesomeIcon icon={faBoxArchive}/></Tooltip></span>
              {eventInfo.event.extendedProps.originalEvent.project?.name}
            </span>
            <small>
              {eventInfo.event.extendedProps.originalEvent.project?.schedulingNotes && <span style={{marginLeft: '5px'}}><Tooltip title={eventInfo.event.extendedProps.originalEvent.project?.schedulingNotes}><FontAwesomeIcon icon={faCalendarEdit}/></Tooltip></span>}
            </small>
            <br />
            <span style={{marginLeft: '5px'}}>
              <small>
              <span style={{marginRight: '5px'}}><Tooltip title="Project Time"><FontAwesomeIcon icon={faStopwatch}/></Tooltip></span>
                {eventInfo.event.extendedProps.originalEvent.project?.hours ?? ''} mh
                {eventInfo.event.extendedProps.originalEvent.manhourDays && ` / (${eventInfo.event.extendedProps.originalEvent.manhourDays} days)`}
              </small>
            </span>
            <br />
            {eventInfo.event.extendedProps.originalEvent.route && <span style={{marginLeft: '5px'}}>
              <small>
                <span style={{marginRight: '5px'}}><Tooltip title="Route"><FontAwesomeIcon icon={faRoute}/></Tooltip></span>
                {eventInfo.event.extendedProps.originalEvent.route.name}
              </small>
            </span>
            }
          </span>
          }
        </span>
    </div>
  )
}

export default CalendarEvent